import React from "react";
import { Link } from "react-router-dom";

const NotFound = ({}) => {
    return (<>
        Sorry, you seem lost!
        <br />
        <br />
        Click <Link to={"/"}>here</Link>. 
    </>);
};

export default NotFound;